import { FunctionComponent } from 'react';

import {
  createCdnIcon,
  CdnIconComponentProps,
} from 'src/designSystem/CdnIcon';

export type StreakHeroTier = {
  min: number;
  icon: string;
  Icon: FunctionComponent<CdnIconComponentProps>;

  iconClassName: string;
  iconAspectClassName: string;
  iconContainerClassName?: string;
  background: string;
  border: string;
  text: string;
};

export const GOLD_HERO_MIN = 5;

const PALIER_ICON_HEIGHT = 'h-[134px]';

const TIERS: Omit<StreakHeroTier, 'Icon'>[] = [
  {
    min: 100,
    icon: 'streak/hero-fireman-v3.svg',
    iconAspectClassName: 'aspect-[207/200]',
    iconClassName: PALIER_ICON_HEIGHT,
    background: 'bg-streak-hero-gold',
    border: 'border-warning-lighter',
    text: 'text-structural-darkest',
  },
  {
    min: 50,
    icon: 'streak/hero-blaze-v3.svg',
    iconAspectClassName: 'aspect-[119/100]',
    iconClassName: PALIER_ICON_HEIGHT,
    background: 'bg-streak-hero-gold',
    border: 'border-warning-lighter',
    text: 'text-structural-darkest',
  },
  {
    min: 25,
    icon: 'streak/hero-snake-v3.svg',
    iconAspectClassName: 'aspect-[73/109]',
    iconClassName: PALIER_ICON_HEIGHT,
    background: 'bg-streak-hero-gold',
    border: 'border-warning-lighter',
    text: 'text-structural-darkest',
  },
  {
    min: 10,
    icon: 'streak/hero-surf-v3.svg',
    iconAspectClassName: 'aspect-[89/100]',
    iconClassName: PALIER_ICON_HEIGHT,
    background: 'bg-streak-hero-gold',
    border: 'border-warning-lighter',
    text: 'text-structural-darkest',
  },
  {
    min: GOLD_HERO_MIN,
    icon: 'streak/hero-tamer-v3.svg',
    iconAspectClassName: 'aspect-[191/200]',
    iconClassName: PALIER_ICON_HEIGHT,
    background: 'bg-streak-hero-gold',
    border: 'border-warning-lighter',
    text: 'text-structural-darkest',
  },
  {
    min: 1,
    icon: 'Flame.svg',
    iconAspectClassName: 'aspect-square',
    iconClassName: 'h-[92px]',
    background: 'bg-streak-hero-purple',
    border: 'border-primary-light',
    text: 'text-structural-lightest',
  },
  {
    min: 0,
    icon: 'Flame.svg',
    iconAspectClassName: 'aspect-square',
    iconClassName: 'h-[92px]',
    iconContainerClassName: 'streak-flame-off',
    background: 'bg-streak-hero-lost',
    border: 'border-structural-light',
    text: 'text-structural-lightest',
  },
];

export const STREAK_HERO_TIERS: StreakHeroTier[] = TIERS.map(tier => ({
  ...tier,
  Icon: createCdnIcon(tier.icon),
}));

export const EXTINGUISHED_TIER: StreakHeroTier =
  STREAK_HERO_TIERS[STREAK_HERO_TIERS.length - 1];

export const streakHeroTier = (streakLength: number): StreakHeroTier =>
  STREAK_HERO_TIERS.find(tier => streakLength >= tier.min) ?? EXTINGUISHED_TIER;
